import LightIcons from "src/FontAwesome/LightIcons";
import SolidIcons from "src/FontAwesome/SolidIcons";
import RegularIcons from "src/FontAwesome/RegularIcons";
import { dom, library } from "@fortawesome/fontawesome-svg-core";

export default function initFontAwesome() {
	library.add(LightIcons);
	library.add(RegularIcons);
	library.add(SolidIcons);

	dom.watch();
}
